"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.default = ({ fill, style }) => (React.createElement("svg", { width: "368", height: "755", style: Object.assign({}, style) },
    React.createElement("defs", null,
        React.createElement("circle", { id: "a", cx: "184", cy: "708", r: "29" })),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { fill: "#E9E9E9", width: "368", height: "755", rx: "56" }),
        React.createElement("rect", { fill: fill, x: "9", y: "9", width: "350", height: "737", rx: "46" }),
        React.createElement("use", { fill: "#FBFBFB" }),
        React.createElement("circle", { stroke: "#E9E9E9", strokeWidth: "4", cx: "184", cy: "708", r: "27" }),
        React.createElement("rect", { fill: "#5D5D5D", x: "21", y: "93", width: "326", height: "574", rx: "3" }),
        React.createElement("rect", { fill: "#D8D8D8", x: "151", y: "46", width: "64", height: "6", rx: "3" }),
        React.createElement("path", { fill: "#FFF", d: "M24 96h320v568H24z" }))));
